<template>
    <img class="header_img" src="@/assets/header.png" style="width: 100%; object-fit: contain"/>
</template>

<script>
    export default {
        name: "Block0"
    }
</script>

<style scoped lang="scss">
    @import "@/styles/variables.scss";

    .header_img {
      display: none;
    }

</style>
